const SERVICE_TYPES = {
  // cpl auth api clients
  CPLAuthAuthenticationClient: Symbol.for("CPLAuthAuthenticationClient"),
  CPLAuthUsersClient: Symbol.for("CPLAuthUsersClient"),
  CPLAuthExampleClient: Symbol.for("CPLAuthExampleClient"),
  CPLAuthLicenceClient: Symbol.for("CPLAuthLicenceClient"),
  CPLAuthMaintenanceClient: Symbol.for("CPLAuthMaintenanceClient"),
  CPLAuthUserGroupsClient: Symbol.for("CPLAuthUserGroupsClient"),
  CPLAuthGoCardlessClient: Symbol.for("CPLAuthGoCardlessClient"),
  CPLAuthTestClient: Symbol.for("CPLAuthTestClient"),
  CPLAuthImpersonationClient: Symbol.for("CPLAuthImpersonationClient"),

  // cpl api clients
  CPLDevelopmentsClient: Symbol.for("CPLDevelopmentsClient"),
  CPLStandardDescriptionsClient: Symbol.for("CPLStandardDescriptionsClient"),
  CPLFundSchedulesClient: Symbol.for("CPLFundSchedulesClient"),
  CPLBlocksClient: Symbol.for("CPLBlocksClient"),
  CPLClientsClient: Symbol.for("CPLClientsClient"),
  CPLJobTypesClient: Symbol.for("CPLJobTypesClient"),
  CPLLegalEntitiesClient: Symbol.for("CPLLegalEntitiesClient"),
  CPLPurchaseAccountInformationClient: Symbol.for("CPLPurchaseAccountInformationClient"),
  CPLUsersClient: Symbol.for("CPLUsersClient"),
  CPLDocumentTypesClient: Symbol.for("CPLDocumentTypesClient"),
  CPLDocumentSubTypesClient: Symbol.for("CPLDocumentSubTypesClient"),
  CPLSLATypesClient: Symbol.for("CPLSLATypesClient"),
  CPLUserTasksClient: Symbol.for("CPLUserTasksClient"),
  CPLUsersSupervisorsClient: Symbol.for("CPLUsersSupervisorsClient"),
  CPLWorkingHoursClient: Symbol.for("CPLWorkingHoursClient"),
  CPLSystemInfoClient: Symbol.for("CPLSystemInfoClient"),
  CPLChangeTrackingClient: Symbol.for("CPLChangeTrackingClient"),
  CPLAuthenticationClient: Symbol.for("CPLAuthenticationClient"),
  CPLCalendarEventsClient: Symbol.for("CPLCalendarEventsClient"),
  CPLTextEditorImageUploadClient: Symbol.for("CPLTextEditorImageUploadClient"),
  CPLCaseTypesClient: Symbol.for("CPLCaseTypesClient"),
  CPLCaseStatusTypesClient: Symbol.for("CPLCaseStatusTypesClient"),
  CPLCasesClient: Symbol.for("CPLCasesClient"),
  CPLMeetingsClient: Symbol.for("CPLMeetingsClient"),
  CPLDirectorsClient: Symbol.for("CPLDirectorsClient"),
  CPLAddressesClient: Symbol.for("CPLAddressesClient"),
  CPLMeetingTypesClient: Symbol.for("CPLMeetingTypesClient"),
  CPLCommentsClient: Symbol.for("CPLCommentsClient"),
  CPLCPLCoreConnectClient: Symbol.for("CPLCPLCoreConnectClient"),
  CPLAuthClientPortalUsersClient: Symbol.for("CPLAuthClientPortalUsersClient"),
  CPLAuthDirectorsClient: Symbol.for("CPLAuthDirectorsClient"),
  CPLDashboardClient: Symbol.for("CPLDashboardClient"),
  CPLJobsClient: Symbol.for("CPLJobsClient"),
  CPLEstimatesClient: Symbol.for("CPLEstimatesClient"),
  CPLSettingsClient: Symbol.for("CPLSettingsClient"),
  CPLAuthCompanyBrandingClient: Symbol.for("CPLAuthCompanyBrandingClient"),
  CPLAuthPermissionsClient: Symbol.for("CPLAuthPermissionsClient"),
  CPLAuthUserMigrationClient: Symbol.for("CPLAuthUserMigrationClient"),
  CPLPaymentProvidersClient: Symbol.for("CPLPaymentProvidersClient"),
  CPLPowerBIClient: Symbol.for("CPLPowerBIClient"),
  CPLTestClient: Symbol.for("CPLTestClient"),
  CPLBackgroundServiceClient: Symbol.for("CPLBackgroundServiceClient"),
  CPLAIChatClient: Symbol.for("CPLAIChatClient"),
  CPLAIInvoicesClient: Symbol.for("CPLAIInvoicesClient"),
  CPLWebNarrativesClient: Symbol.for("CPLWebNarrativesClient"),
  CPLCPL3SettingsClient: Symbol.for("CPLCPL3SettingsClient"),
  CPLDirectDebitCollectionDaysClient: Symbol.for("CPLDirectDebitCollectionDaysClient"),
  CPLResumableProcessClient: Symbol.for("CPLResumableProcessClient"),
  CPLServiceChargeInvoicingClient: Symbol.for("CPLServiceChargeInvoicingClient"),
  CPLServiceChargeInvoicingSettingsClient: Symbol.for("CPLServiceChargeInvoicingSettingsClient"),
  CPLAnticipatedExpenditureClient: Symbol.for("CPLAnticipatedExpenditureClient"),
  CPLServiceChargeInvoicingSummariesClient: Symbol.for("CPLServiceChargeInvoicingSummariesClient"),
  CPLFundHeaderClient: Symbol.for("CPLFundHeaderClient"),
  CPLSelfServeDataImportSubmissionsClient: Symbol.for("CPLSelfServeDataImportSubmissionsClient"),
  CPLSelfServeDataImportSubmissionFilesClient: Symbol.for("CPLSelfServeDataImportSubmissionFilesClient"),
  CPLSelfServeDataImportSubmissionSheetMappingsClient: Symbol.for(
    "CPLSelfServeDataImportSubmissionSheetMappingsClient"
  ),
  CPLSelfServeDataImportSubmissionColumnMappingsClient: Symbol.for(
    "CPLSelfServeDataImportSubmissionColumnMappingsClient"
  ),
  CPLSelfServeDataImportSubmissionValidationResultsClient: Symbol.for(
    "CPLSelfServeDataImportSubmissionValidationResultsClient"
  ),
  CPLSelfServeDataImportSubmissionEditsClient: Symbol.for("CPLSelfServeDataImportSubmissionEditsClient"),
  CPLSelfServeDataImportSubmissionBundlesClient: Symbol.for("CPLSelfServeDataImportSubmissionBundlesClient"),
  CPLSelfServeDataImportSubmissionLocksClient: Symbol.for("CPLSelfServeDataImportSubmissionLocksClient"),
  CPLTypesClient: Symbol.for("CPLTypesClient"),

  // services
  ExampleService: Symbol.for("ExampleService"),
  ExampleService2: Symbol.for("ExampleService2"),
  AuthenticationService: Symbol.for("AuthenticationService"),
  SessionService: Symbol.for("SessionService"),
  AuthUsersService: Symbol.for("AuthUsersService"),
  LicenceService: Symbol.for("LicenceService"),
  DevelopmentsService: Symbol.for("DevelopmentsService"),
  StandardDescriptionsService: Symbol.for("StandardDescriptionsService"),
  FundSchedulesService: Symbol.for("FundSchedulesService"),
  BlocksService: Symbol.for("BlocksService"),
  ClientsService: Symbol.for("ClientsService"),
  JobTypesService: Symbol.for("JobTypesService"),
  CountriesService: Symbol.for("CountriesService"),
  LegalEntitiesService: Symbol.for("LegalEntitiesService"),
  PurchaseAccountInformationService: Symbol.for("PurchaseAccountInformationService"),
  UsersService: Symbol.for("UsersService"),
  DocumentTypesService: Symbol.for("DocumentTypesService"),
  DocumentSubTypesService: Symbol.for("DocumentSubTypesService"),
  SLATypesService: Symbol.for("SLATypesService"),
  UserSettingsService: Symbol.for("UserSettingsService"),
  UserTasksService: Symbol.for("UserTasksService"),
  UsersSupervisorsService: Symbol.for("UsersSupervisorsService"),
  UserGroupsService: Symbol.for("UserGroupsService"),
  WorkingHoursService: Symbol.for("WorkingHoursService"),
  SystemInfoService: Symbol.for("SystemInfoService"),
  ChangeTrackingService: Symbol.for("ChangeTrackingService"),
  CalendarEventService: Symbol.for("CalendarEventService"),
  TextEditorImageUploadService: Symbol.for("TextEditorImageUploadService"),
  CaseTypesService: Symbol.for("CaseTypesService"),
  CaseStatusTypesService: Symbol.for("CaseStatusTypesService"),
  CasesService: Symbol.for("CasesService"),
  MeetingsService: Symbol.for("MeetingsService"),
  DirectorsService: Symbol.for("DirectorsService"),
  AddressesService: Symbol.for("AddressesService"),
  MeetingTypesService: Symbol.for("MeetingTypesService"),
  CommentsService: Symbol.for("CommentsService"),
  CPLCoreConnectService: Symbol.for("CPLCoreConnectService"),
  ClientPortalUsersService: Symbol.for("ClientPortalUsersService"),
  DashboardService: Symbol.for("DashboardService"),
  JobsService: Symbol.for("JobsService"),
  EstimatesService: Symbol.for("EstimatesService"),
  SettingsService: Symbol.for("SettingsService"),
  CompanyBrandingService: Symbol.for("CompanyBrandingService"),
  PermissionService: Symbol.for("PermissionsService"),
  UserMigrationService: Symbol.for("UserMigrationService"),
  PaymentProvidersService: Symbol.for("PaymentProvidersService"),
  GoCardlessService: Symbol.for("GoCardlessService"),
  PowerBIService: Symbol.for("PowerBIService"),
  TestService: Symbol.for("TestService"),
  BackgroundServiceService: Symbol.for("BackgroundServiceService"),
  AuthTestService: Symbol.for("AuthTestService"),
  AIAssistantService: Symbol.for("AIAssistantService"),
  AIInvoicesService: Symbol.for("AIInvoicesService"),
  MaintenanceService: Symbol.for("MaintenanceService"),
  WebNarrativesService: Symbol.for("WebNarrativesService"),
  CPLSettingsService: Symbol.for("CPLSettingsService"),
  DirectDebitCollectionDaysService: Symbol.for("DirectDebitCollectionDaysService"),
  ResumableProcessService: Symbol.for("ResumableProcessService"),
  ServiceChargeInvoicingService: Symbol.for("ServiceChargeInvoicingService"),
  ServiceChargeInvoiceSettingsService: Symbol.for("ServiceChargeInvoiceSettingsService"),
  AnticipatedExpenditureReportService: Symbol.for("AnticipatedExpenditureReportService"),
  ServiceChargeInvoicingSummariesService: Symbol.for("ServiceChargeInvoicingSummariesService"),
  FundHeaderService: Symbol.for("FundHeaderService"),
  ImpersonationService: Symbol.for("ImpersonationService"),
  DataImportService: Symbol.for("DataImportService"),
};

export { SERVICE_TYPES };
